define('models/shared/qanda/questionsandanswersres',["backbone"
], function (Backbone) {

    var QuestionandAnswers = Backbone.Model.extend({
        urlRoot: function () {
            return pf.consumerURL + "/OutOfWallet";
        },
        initialize: function (options) {

            options || (options = {});
            this.transactionID = options.TID;
            this.questionSetID = options.QSID;
            this.transactionResult = options.TR;
            this.detailCode = options.DC;
            this.transactionText = options.TT;
            this.lexID = options.LID;
            this.dateAttempted = options.DA;
            this.howManyRouts = options.HMR;
            this.questionID1 = options.QID1;
            this.questionID2 = options.QID2;
            this.questionID3 = options.QID3;
            this.choiceID1 = options.CID1;
            this.choiceID2 = options.CID2;
            this.choiceID3 = options.CID3;
            this.cardType = options.CT;
            this.SSN4 = options.SSN4;
            this.Email = options.E;
            this.FirstName = options.FN;
            this.LastName = options.LN;
            this.AddressLine1 = options.AL1;
            this.AddressLine2 = options.AL2;
            this.Zip = options.Z;
            this.ZipID = options.ZID;
            this.City = options.C;
            this.Phone = options.P;
            this.State = options.S;
            this.StateID = options.STID;
            this.StateAbr = options.SA;
            this.DOB = options.DOB;
            this.UserGUID = options.UG;
            this.CIPResultID = options.CIPRID;
            this.SMS = options.SMS;
            this.OIWP = options.OIWP;
        },
        parse: function (data) {

            var response = {};
            response.transactionID = data.TID;
            response.questionSetID = data.QSID;
            response.transactionResult = data.TR;
            response.detailCode = data.DC;
            response.transactionText = data.TT;
            response.lexID = data.LID;
            response.dateAttempted = data.DA;
            response.howManyRouts = data.HMR;
            response.questionID1 = data.QID1;
            response.questionID2 = data.QID2;
            response.questionID3 = data.QID3;
            response.choiceID1 = data.CID1;
            response.choiceID2 = data.CID2;
            response.choiceID3 = data.CID3;
            response.cardType = data.CT;
            response.SSN4 = data.SSN4;
            response.Email = data.EM;
            response.FirstName = data.FN;
            response.LastName = data.LN;
            response.AddressLine1 = data.AL1;
            response.AddressLine2 = data.AL2;
            response.Zip = data.Z;
            response.ZipID = data.ZID;
            response.City = data.C;
            response.Phone = data.P;
            response.State = data.S;
            response.StateAbr = data.SA;
            response.StateID = data.STID;
            response.DOB = data.DOB;
            response.UserGUID = data.UG;
            response.CIPResultID = data.CIPRID;
            response.SMS = data.SMS;
            response.OIWP = data.OIWP;
            return response;
        },
        save: function (attributes, options) {

            options = options || {};
            attributes = attributes || {};
            var data = {};

            data.TID = this.transactionID;
            data.QSID = this.questionSetID;
            data.TR = this.transactionResult;
            data.DC = this.detailCode;
            data.TT = this.transactionText;
            data.LID = this.lexID;
            data.DA = this.dateAttempted;
            data.HMR = this.howManyRouts;
            data.QID1 = this.questionID1;
            data.QID2 = this.questionID2;
            data.QID3 = this.questionID3;
            data.CID1 = this.choiceID1;
            data.CID2 = this.choiceID2;
            data.CID3 = this.choiceID3;
            data.CT = this.cardType;
            data.SSN4 = this.SSN4;
            data.Email = this.Email;
            data.FN = this.FirstName;
            data.LN = this.LastName;
            data.AL1 = this.AddressLine1 ;
            data.AL2 = this.AddressLine2;
            data.Z = this.Zip;
            data.ZID = this.ZipID;
            data.C = this.City ;
            data.P = this.Phone;
            data.S = this.State;
            data.SA = this.StateAbr;
            data.STID = this.StateID;
            data.DOB = this.DOB;
            data.UG = this.UserGUID;
            data.CIPRID = this.CIPResultID;
            data.SMS = this.SMS;
            data.OIWP = this.OIWP;
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return QuestionandAnswers;
});

